import { Component, Input, OnInit } from "@angular/core";
import { PopNotificationsService } from "@core/services/pop-notifications.service";
import { WindowRefService } from "@core/services/window-ref.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "astrobin-export-acquisitions-to-csv-modal",
  templateUrl: "./export-acquisitions-to-csv-modal.component.html",
  styleUrls: ["./export-acquisitions-to-csv-modal.component.scss"]
})
export class ExportAcquisitionsToCsvModalComponent implements OnInit {
  @Input() headers: string[] = [];
  @Input() acquisitions: any[] = [];

  csvContent = "";
  loading = true;

  constructor(
    public readonly modal: NgbActiveModal,
    public readonly translateService: TranslateService,
    private readonly popNotificationsService: PopNotificationsService,
    private readonly windowRefService: WindowRefService
  ) {}

  ngOnInit(): void {
    this._generateCsv();
  }

  onCopyToClipboard(): void {
    void this.windowRefService.copyToClipboard(this.csvContent).then(success => {
      if (success) {
        this.popNotificationsService.success(this.translateService.instant("CSV data copied to clipboard"));
        this.modal.close();
      } else {
        this.popNotificationsService.error(this.translateService.instant("Failed to copy to clipboard"));
      }
    });
  }

  private _generateCsv(): void {
    // Simulate some processing time and show progress
    setTimeout(() => {
      try {
        const csvRows = [this.headers.join(",")];

        this.acquisitions.forEach((acquisition, index) => {
          const row = this.headers.map(header => {
            const value = acquisition[header === "filter" ? "filter2" : header];

            // Handle null/undefined values
            if (value === null || value === undefined) {
              return "";
            }

            // Convert to string and handle any commas in values
            const stringValue = String(value);
            if (stringValue.includes(",") || stringValue.includes('"') || stringValue.includes("\n")) {
              // Escape quotes and wrap in quotes
              return `"${stringValue.replace(/"/g, '""')}"`;
            }

            return stringValue;
          });

          csvRows.push(row.join(","));
        });

        this.csvContent = csvRows.join("\n");
        this.loading = false;
      } catch (error) {
        console.error("Error generating CSV:", error);
        this.popNotificationsService.error(this.translateService.instant("Error generating CSV data"));
        this.modal.dismiss();
      }
    }, 100);
  }
}
